import { PreQualifyFormValues } from '@components/forms/PreQualifyForm/schemas/preQualifyFormSchema';
import PreQualifyFormFields from '@enums/preQualifyForm';
import { Referrer } from '@utils/referrer';
import { MarketingCaptureType } from '../../types/MarketingCaptureType';

export const MARKETING_CAPTURE_SOURCE_SITE = 'coign-site';
export const MARKETING_CAPTURE_SOURCE_FORM = 'ready-to-apply';

export const mapToMarketingCaptureType = (
  formValues: PreQualifyFormValues,
  prospectId: string,
  applicationId: string,
  referrer: Referrer
): MarketingCaptureType => {
  return {
    prospectId,
    applicationId,
    sourceSite: MARKETING_CAPTURE_SOURCE_SITE,
    sourceForm: MARKETING_CAPTURE_SOURCE_FORM,
    // The mini-form only ever sends these three fields plus the referral that
    // brought the visitor here — no SSN, verification codes or banking data
    // reaches the capture store from this site.
    payload: {
      [PreQualifyFormFields.FirstName]:
        formValues[PreQualifyFormFields.FirstName],
      [PreQualifyFormFields.LastName]:
        formValues[PreQualifyFormFields.LastName],
      [PreQualifyFormFields.Email]: formValues[PreQualifyFormFields.Email],
      // Absent rather than empty for an organic visit: a blank key would land
      // on every prospect record and show up in the backend's changedFields.
      // The type only says which kind of id `referrerId` is, so it never
      // travels alone.
      ...(referrer.referrerId
        ? {
            referrerId: referrer.referrerId,
            ...(referrer.referrerIdType
              ? { referrerIdType: referrer.referrerIdType }
              : {}),
          }
        : {}),
    },
  };
};
